import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.modules';
import { AppShellComponent } from './app-shell/app-shell.component';
import { AuthGuard } from './guards/auth.guard';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { BsDropdownModule, TabsModule } from 'ngx-bootstrap';
import { IntercomModule } from 'ng-intercom';

import { environment } from 'environments/environment';
import { AppComponent } from './app.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { LoginComponent } from './auth/login/login.component';
import { NewPasswordComponent } from './auth/new-password/new-password.component';
import { UnauthorisedComponent } from './auth/unauthorised/unauthorised.component';
import { CoreModule } from './core/core.module';
import { HttpCustomInterceptor } from './core/http-custom-interceptor';
import { AutosetService } from './locations/autosets.service';
import { LocationService } from './locations/location.service';
import { RoomService } from './locations/room.service';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { NotificationsService } from './notifications/notifications.service';
import { NotificationsModule } from './notifications/notifications.module';
import { TestPageService } from './test-page/test-page.service';
import { TestPageModule } from './test-page/test-page.module';
import { LocationStatusModule } from './location-status/location-status.module';
import { GatewayStatusModule } from './gateway-status/gateway-status.module';
import { GatewayReportModule } from './gateway-status/reports/gateway-report.module';
import { NodeGraphModule } from './location-status/node-graphs/node-graph.module';
import { ReportModule } from './reports/report.module';
import { GatewaySetupModule } from './gateway-setup/gateway-setup.module';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { IntercomService } from './shared/intercom.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from './locations/modal.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UnauthorisedComponent,
    AppShellComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    ForgotComponent,
    NewPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    BrowserModule,
    environment.production ? ServiceWorkerModule.register('/ngsw-worker.js') : [],
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    MyDateRangePickerModule,
    CoreModule,
    NotificationsModule,
    TestPageModule,
    LocationStatusModule,
    GatewayStatusModule,
    GatewayReportModule,
    NodeGraphModule,
    ReportModule,
    NgbModule,
    GatewaySetupModule,
    IntercomModule.forRoot({
      appId: 'jhd0ofyt',
      updateOnRouterChange: true
    })
  ],
  // TODO After refactoring DashboardService, move any singleton services whose instance will be shared throughout the application to the CoreModule.
  providers: [
    LocationService,
    RoomService,
    AutosetService,
    AuthGuard,
    NotificationsService,
    TestPageService,
    IntercomService,
    ModalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCustomInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/app.module.ts